import axios from 'axios';

import { mapServerError } from '../../services/utils/serverErrorMapper';

const isProd = window.location?.host?.includes('portal.flipdish.com');

const clientsBaseUrl = isProd
  ? 'https://api.portal.flipdish.com/onboarding'
  : 'https://clients-integration.portal.flipdishdev.com';

const clientsApi = axios.create({
  baseURL: clientsBaseUrl,
  withCredentials: true,
});

export const getOnboardingV3StatusKey = 'getOnboardingConfigKey';
export const getOnboardingV3Status = (orgId: string) => {
  return clientsApi.get(`/orgs/${orgId}/status`).catch((error) => {
    throw mapServerError(error);
  });
};

export const getVatNumberForOrgKey = 'getVatNumberForOrg';
export const getVatNumberForOrg = (orgId: string) => {
  return clientsApi.get(`/org/${orgId}/vat-number`).catch((error) => {
    throw mapServerError(error);
  });
};
